import * as React from "react";
import type { SVGProps } from "react";
const SvgProduct = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    width="1em"
    height="1em"
    role="img"
    focusable={false}
    {...props}
  >
    <path d="M12.175 7.767h-.1V5.75a1.15 1.15 0 0 0-.692-1.058v-.767c.259-.442.325-.833.175-1.058a.69.69 0 0 0-.608-.367q-1.01.114-1.983.4a.9.9 0 0 0-.5.992v.833a1.14 1.14 0 0 0-.526.958v2.084h-.1a1.15 1.15 0 0 0-1.174 1.15v7.55a1.15 1.15 0 0 0 1.15 1.15h4.333a1.15 1.15 0 0 0 1.183-1.15v-7.55a1.15 1.15 0 0 0-1.158-1.15m-3.092-3.9s-.05-.292.133-.375a10 10 0 0 1 1.792-.334s0 .125-.208.509a.4.4 0 0 0-.042.166V4.6H9.092zm-.517 1.875a.525.525 0 0 1 .525-.517h1.842a.525.525 0 0 1 .517.525v2.017H8.567zm4.167 10.725a.525.525 0 0 1-.525.525H7.842a.525.525 0 0 1-.526-.525v-7.55a.525.525 0 0 1 .526-.525h4.333a.525.525 0 0 1 .525.525z" />
  </svg>
);
export default SvgProduct;
